import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Margin } from 'styled-components-spacing';
import ReactPlaceholder from 'react-placeholder';

import { savedPackagesOperations } from 'state/savedPackages';
import { createPackageCards } from 'components/packageCard/PackageCardFactory';
import { RECOMMENDED_PACKAGES_PACKAGE } from 'components/packageCard/constants/packageTypes';
import PackageCardSmallPlaceholder from 'components/packageCard/PackageCardSmallPlaceholder';
import CarouselThemePackages from './CarouselThemePackages';

import chevron from 'static/icons/chevron.svg';

class ThemeBoxPackages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cards: [],
    };

    this.handleOnClickPrevPackage = this.handleOnClickPrevPackage.bind(this);
    this.handleOnClickNextPackage = this.handleOnClickNextPackage.bind(this);
    this.assignCarouselRef = this.assignCarouselRef.bind(this);
  }

  componentDidMount() {
    if (this.props.packages && this.props.packages.length > 0) {
      this.setState({
        cards: createPackageCards({
          packages: this.props.packages,
          packageType: RECOMMENDED_PACKAGES_PACKAGE,
          configuration: {
            small: true,
            target: '_self',
            maxWidth: '742px',
          },
          data: {
            uniqueKeyHelp: this.props.themeId,
          },
          events: {
            onClickAddHearted: this.props.addSavedPackages,
            onClickRemoveHearted: this.props.removeSavedPackages,
          },
        }),
      });
    }
  }

  componentDidUpdate() {
    if (this.state.cards.length === 0 && this.props.packages && this.props.packages.length > 0) {
      this.setState({
        cards: createPackageCards({
          packages: this.props.packages,
          packageType: RECOMMENDED_PACKAGES_PACKAGE,
          configuration: {
            small: true,
            target: '_self',
            maxWidth: '742px',
          },
          data: {
            uniqueKeyHelp: this.props.themeId,
          },
          events: {
            onClickAddHearted: this.props.addSavedPackages,
            onClickRemoveHearted: this.props.removeSavedPackages,
          },
        }),
      });
    }
  }

  handleOnClickPrevPackage() {
    this.slider && this.slider.slickPrev();
  }

  handleOnClickNextPackage() {
    this.slider && this.slider.slickNext();
  }

  assignCarouselRef(refValue) {
    this.slider = refValue;
  }

  render() {
    const removePlaceholder = this.state.cards.length !== 0;
    const cards = this.state.cards;

    return (
      <Container>
        <Navigation packagesLoaded={removePlaceholder}>
          <Button onClick={this.handleOnClickPrevPackage} isPrev>
            <img src={chevron} alt='previous package' />
          </Button>
          <Margin right='0.5' inline={true} />
          <Button onClick={this.handleOnClickNextPackage} isNext>
            <img src={chevron} alt='next package' />
          </Button>
        </Navigation>
        <HotelsList>
          <ReactPlaceholder
            ready={removePlaceholder}
            showLoadingAnimation={true}
            customPlaceholder={<PackageCardSmallPlaceholder />}
          >
            {removePlaceholder ? (
              <CarouselThemePackages
                items={cards}
                assignCarouselRef={this.assignCarouselRef}
                themeId={this.props.themeId}
              />
            ) : (
              <div></div>
            )}
          </ReactPlaceholder>
        </HotelsList>
      </Container>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addSavedPackages: function (packet) {
      dispatch(savedPackagesOperations.updateSavedPackages(null, packet));
    },
    removeSavedPackages: function (id) {
      dispatch(savedPackagesOperations.updateSavedPackages(id, null));
    },
  };
}

export default connect(null, mapDispatchToProps)(ThemeBoxPackages);

const Container = styled.div`
  position: relative;
`;

const Navigation = styled.div`
  display: ${({ packagesLoaded }) => (packagesLoaded ? 'block' : 'none')};
  position: absolute;
  right: 0;
  top: -67px;
`;

const Button = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.background.light};
  cursor: pointer;

  img {
    width: 7px;
  }

  ${({ isPrev }) =>
    isPrev &&
    `
    img {
      position: relative;
      left: -1px;
      transform: rotate(180deg);
    }
  `}

  ${({ isNext }) =>
    isNext &&
    `
    img {
      position: relative;
      left: 1px;
    }
  `}
`;

const HotelsList = styled.div``;
